import React, { useEffect, useState,useRef } from 'react';
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import {
    badge,
    sliderImg1,
    sliderImg2,
    sliderImg3,
    sliderImg4,
    sliderImg5,
} from '../../../assets/img/index';
import { FaEthereum } from 'react-icons/fa';
import { SiBinance, SiPolymerproject } from 'react-icons/si';

export default function CompletedProjectScroller() {
    const Ref = useRef(null)
    const [timer, setTimer] = useState('00:00:00')
    const slider = [
        {
            img: sliderImg1,
            name: '@xander_hall...',
            price: 10000,
            TotalPrize: 13500,
            days: '2 days ago',
            img2: badge,
            token: <FaEthereum className='m-2 badgeIcon' style={{ color: 'gray' }} />,
        },
        {
            img: sliderImg2,
            name: '@hamza_pitts...',
            days: '12 days ago',
            TotalPrize: 15000,
            price: 12000,
            img2: badge,
            token: (
                <SiPolymerproject
                    className='m-2 badgeIcon'
                    style={{ color: 'purple' }}
                />
            ),
        },
        {
            img: sliderImg3,
            name: '@nathan_walls...',
            days: '19 days ago',
            TotalPrize: 10000,
            price: 10000,
            img2: badge,
            token: (
                <SiBinance className='m-2 badgeIcon' style={{ color: 'yellow' }} />
            ),
        },
        {
            img: sliderImg4,
            name: '@kelton_colier...',
            days: '15 days ago',
            TotalPrize: 15000,
            price: 145000,
            img2: badge,
            token: <FaEthereum className='m-2 badgeIcon' style={{ color: 'gray' }} />,
        },
        {
            img: sliderImg5,
            name: '@cade_glover...',
            days: '16 days ago',
            TotalPrize: 23000,
            price: 17000,
            img2: badge,
            token: (
                <SiPolymerproject
                    className='m-2 badgeIcon'
                    style={{ color: 'purple' }}
                />
            ),
        },
        // {
        //     img: sliderImg6,
        //     name: "@xander_hall...",
        //     price: "16.58 ETH",
        //     img2: badge,
        //     token: <SiBinance size={18} className='m-2' style={{ color: "yellow" }} />
        // },
        // {
        //     img: sliderImg7,
        //     name: "@hamza_pitts...",
        //     price: "14.55 ETH",
        //     img2: badge,
        //     token: <FaEthereum size={18} className='m-2' style={{ color: "gray" }} />
        // },
        // {
        //     img: sliderImg8,
        //     name: "@nathan_walls...",
        //     price: "24.13 ETH",
        //     img2: badge,
        //     token: <SiBinance size={18} className='m-2' style={{ color: "gray" }} />

        // },
        // {
        //     img: avatar4,
        //     name: "@kelton_colier...",
        //     price: "62.68 ETH",
        //     img2: badge,
        // },
        // {
        //     img: avatar5,
        //     name: "@cade_glover...",
        //     price: "32.48 ETH",
        //     img2: badge,
        // },
    ]

    const getTimeRemaining = (e) => {
        const total = Date.parse(e) - Date.parse(new Date())
        const seconds = Math.floor((total / 1000) % 60)
        const minutes = Math.floor((total / 1000 / 60) % 60)
        const hours = Math.floor((total / 1000 / 60 / 60) % 24)
        return {
            total,
            hours,
            minutes,
            seconds,
        }
    }

    const startTimer = (e) => {
        let { total, hours, minutes, seconds } = getTimeRemaining(e)
        if (total >= 0) {
            // update the timer
            // check if less than 10 then we need to
            // add '0' at the beginning of the variable
            setTimer(
                (hours > 9 ? hours : '0' + hours) +
                ':' +
                (minutes > 9 ? minutes : '0' + minutes) +
                ':' +
                (seconds > 9 ? seconds : '0' + seconds),
            )
        }
    }

    const clearTimer = (e) => {
        // If you adjust it you should also need to
        // adjust the Endtime formula we are about
        // to code next
        setTimer('00:00:10')

        // If you try to remove this line the
        // updating of timer Variable will be
        // after 1000ms or 1sec
        if (Ref.current) clearInterval(Ref.current)
        const id = setInterval(() => {
            startTimer(e)
        }, 1000)
        Ref.current = id
    }

    const getDeadTime = () => {
        let deadline = new Date()

        // This is where you need to adjust if
        // you entend to add more time
        deadline.setSeconds(deadline.getSeconds() + 100000)
        return deadline
    }
    useEffect(() => {
        clearTimer(getDeadTime())
    }, [])

    return (
        <>
        <div className='scroller__class'>

            <div style={{}} className="sp-bottm2x sp-top-1  mr-left mr-right  ">
                {slider.map((slider) => (
                    <>
                    <div className=''>

                        <div className="CompletedIDOslider" style={{ cursor: 'pointer' }}>
                            <div
                                className="space-x-10 IO d-flex"
                                style={{ flexDirection: 'column', alignItems: 'center' }}
                            >
                                <div
                                  style={{}}  className="d-flex align-items-center justify-content-between m-2 w-100"
                                >
                                    <div
                                        className="d-flex ms-3"
                                        style={{ borderRadius: '1.5vw' }}
                                    >
                                        <div className='' style={{marginLeft:'10px'}}>
                                            <img
                                                src={slider.img}
                                                style={{
                                                    background: 'white',
                                                    borderRadius: '0.5vw',
                                                }}
                                                className="Completed_img"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className="border rounded-circle"
                                        style={{background: 'rgba(247, 240, 244, 0.8)' }}
                                    >
                                        {slider.token}
                                    </div>
                                    <div className='p3'>{slider.days}</div>
                                    <div className="mr-2">
                                        <div>
                                            <span className='p3'>Raised Amount</span>
                                        </div>
                                        <div>
                                            <span className='p3'> {slider.price} /</span>
                                            <span className="ms-2 p3" style={{ color: '#CAE620' }}>{slider.TotalPrize} BUSD</span>
                                        </div>

                                        <div className="progress mt-2" style={{ height: "10px" }}>
                                            <div className="progress-bar" role="progressbar" style={{ width: `${(slider.price / slider.TotalPrize) * 100}%`, height: '10px' }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="CompletedIDOslider1" style={{ cursor: 'pointer' }}>
                            <div
                                className="space-x-10 d-flex"
                                style={{ flexDirection: 'column', alignItems: 'center' }}
                            >
                                <div
                                    className="d-flex align-items-center justify-content-between m-4 w-100"
                                    style={{ flexDirection: 'column'}}
                                >
                                    <div className="d-flex ">
                                        <div style={{ marginTop: '-1rem' }}>
                                            <img
                                                className="CompletedIDOslider1Img"
                                                src={slider.img}
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className="d-flex align-items-center justify-content-between"
                                        style={{ width: '95%' }}
                                    >
                                        <div
                                            className="border rounded-circle  m-2"
                                            style={{ background: 'rgba(247, 240, 244, 0.8)' }}
                                        >
                                            {slider.token}
                                        </div>
                                        <div>{slider.days}</div>
                                    </div>
                                    <div
                                        className="d-flex align-items-center justify-content-between"
                                        style={{ marginRight:'10px' }}>
                                        <div>
                                            <span>Raised Amount</span>
                                        </div>
                                        <div>
                                            <div>
                                                <span style={{ color: 'blue' }}> {slider.price} </span>
                                                <span>/ {slider.TotalPrize} BUSD</span>
                                            </div>
                                            <div className="my-3">
                                                <input
                                                    type="range"
                                                    min="0"
                                                    max={slider.TotalPrize}
                                                    value={slider.price}
                                                    name=""
                                                    id=""
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {'\u00A0'}
                        </div>
                    </>
                ))}
                {/* </Slider> */}
            </div>
        </div>
        </>
    )
    // }
}
